<template>
  <div class="authorshist">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search historical authors"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="authorhists.length" class="results-ul">
            <li v-for="authorhist in authorhists" :key="authorhist.id">
              <a href="#" @click="selectAuthorhist($event, authorhist)" v-html="authorhist.sigleLegam"></a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AuthorhistAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.authorhist.authorhists = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.authorhist.authorhists = []
    },
    computed: {
      ...mapState({
        authorhists: state => state.authorhist.authorhists
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectAuthorhist(event, authorhist){
        event.preventDefault()
        this.$emit('select', authorhist)
        this.$store.state.authorhist.authorhists = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchAuthorhists', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
